import { AvailableShortcutsType } from './ShortcutHelper.props';

const formulaRowAndLegendsCombination = {
  combination: {
    windows: 'Ctrl + `',
    macOS: 'Control + =',
  },
};

export enum ACTION_SHORTCUT {
  ADD = 'Add',
  NEXT_TAB = 'Next Tab',
  PREVIOUS_TAB = 'Previous Tab',
  EDIT_SELECTED_CELL = 'Edit Selected Cell',
  SAVE = 'Save',
  SHOW_ROW_NUMBERS_AND_COLUMN_LABELS = 'Show row numbers and column labels (1st time)',
  SHOW_FORMULA = 'Show Formula (2nd time)',
  HIDE_FORMULA_ROW_NUMBERS_AND_COLUMN_LABELS = 'Hide Formula, Row Numbers and Column Labels (3rd time)',
  PUSH_ATTRIBUTE_MAPPINGS = 'Push Attribute Mappings',
  OPEN_DRAWER = 'Open Drawer',
  CLOSE_DRAWER = 'Close Drawer',
  MAKE_DRAWER_TALLER = 'Make Drawer Taller',
  OPEN_COMPANIES_SEARCH = 'Open Companies Search',
}

const availableShortcuts: AvailableShortcutsType[] = [
  {
    action: ACTION_SHORTCUT.ADD,
    combination: {
      windows: 'Alt + N',
      macOS: 'Control + N',
    },
  },
  {
    action: ACTION_SHORTCUT.NEXT_TAB,
    combination: {
      windows: 'Alt + Page Up',
      macOS: 'Option + Fn + ArrowKey Up',
    },
  },
  {
    action: ACTION_SHORTCUT.PREVIOUS_TAB,
    combination: {
      windows: 'Alt + Page Down',
      macOS: 'Option + Fn + ArrowKey Up',
    },
  },
  {
    action: ACTION_SHORTCUT.EDIT_SELECTED_CELL,
    combination: {
      windows: 'F2',
      macOS: 'F2',
    },
  },
  {
    action: ACTION_SHORTCUT.SAVE,
    combination: {
      windows: 'Ctrl + .',
      macOS: 'Control + .',
    },
  },
  {
    action: ACTION_SHORTCUT.SHOW_ROW_NUMBERS_AND_COLUMN_LABELS,
    ...formulaRowAndLegendsCombination,
  },
  {
    action: ACTION_SHORTCUT.SHOW_FORMULA,
    ...formulaRowAndLegendsCombination,
  },
  {
    action: ACTION_SHORTCUT.HIDE_FORMULA_ROW_NUMBERS_AND_COLUMN_LABELS,
    ...formulaRowAndLegendsCombination,
  },
  {
    action: ACTION_SHORTCUT.PUSH_ATTRIBUTE_MAPPINGS,
    combination: {
      windows: 'Alt + p',
      macOS: 'Control + p',
    },
  },
  {
    action: ACTION_SHORTCUT.OPEN_DRAWER,
    combination: {
      windows: 'Alt + o',
      macOS: 'Control + o',
    },
  },
  {
    action: ACTION_SHORTCUT.CLOSE_DRAWER,
    combination: {
      windows: 'Alt + c',
      macOS: 'Control + c',
    },
  },
  {
    action: ACTION_SHORTCUT.MAKE_DRAWER_TALLER,
    combination: {
      windows: 'Alt + ArrowKey Up',
      macOS: 'Control + ArrowKey Up',
    },
  },
  {
    action: ACTION_SHORTCUT.OPEN_COMPANIES_SEARCH,
    combination: {
      windows: 'Ctrl + K',
      macOS: 'Command + K',
    },
  },
];

export default availableShortcuts;
